<template>
  <div>
    <h4 class="tab_style">{{ $t("gen_info") }}</h4>
    <p class="tab_style_sub_tekst">{{ $t("gen_data") }}</p>
    <v-divider class="mb-4"></v-divider>

    <v-form v-model="valid">
      <v-row dense>
        <v-col cols="12" sm="6">
          <text-field v-model="localUser.id" :label="$t('id')" disabled></text-field>
        </v-col>
        <v-col cols="12" sm="6"></v-col>

        <v-col cols="12" sm="6">
          <text-field
            v-model="localUser.name"
            :label="$t('name')"
            :rules="[rules.required, rules.firstName]"
            required
          ></text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <text-field v-model="localUser.lastname" :label="$t('last_name')"></text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <text-field
            v-model="localUser.email"
            :label="$t('email')"
            :rules="[rules.required]"
            required
          ></text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <text-field
            v-model="localUser.phone"
            :label="$t('phone_no')"
            kind="phone"
            :rules="[rules.phone]"
          ></text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <autocomplete
            @change="handleCountryChange"
            :items="countries"
            item-value="id"
            item-text="name"
            v-model="localUser.country"
            :label="$t('country')"
          />
        </v-col>

        <v-col cols="12" sm="6">
          <autocomplete
            :items="cities"
            item-value="id"
            item-text="name"
            v-model="localUser.city_id"
            :label="$t('city')"
          />
        </v-col>

        <v-col cols="12" sm="6">
          <text-field v-model="localUser.address" :label="$t('address')"></text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <autocomplete
            v-model="notification"
            :items="notificationItems"
            :label="$t('select_notification')"
          />
        </v-col>

        <v-col cols="12">
          <text-field
            v-model="password"
            :label="$t('pass_confirm')"
            prepend-inner-icon="mdi-lock"
            type="password"
          ></text-field>
        </v-col>

        <v-col cols="12">
          <primary-button @click="handleUpdate" block :disabled="!valid">
            {{ $t("verify_change") }}
          </primary-button>
        </v-col>

        <v-col cols="12" class="mt-4">
          <v-divider class="mb-4"></v-divider>
          <h4 class="tab_style error--text mb-2">{{ $t("danger_zone") }}</h4>
          <p class="tab_style_sub_tekst mb-3">{{ $t("delete_profile_warning") }}</p>
          <v-btn color="error" outlined block @click="$emit('delete-profile')">
            <v-icon left>mdi-account-remove</v-icon>
            {{ $t("delete_profile") }}
          </v-btn>
        </v-col>
      </v-row>

      <v-alert dense outlined type="error" v-if="failed" class="mt-4">
        {{ $t("incorrect_password") }}
      </v-alert>
    </v-form>
  </div>
</template>

<script>
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";
import userService from "@/services/user";
import restaurantService from "@/services/restaurant";

export default {
  name: "ProfileGeneralInfo",
  mixins: [hasValidation, hasSnackbar],
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      valid: false,
      localUser: { ...this.user },
      countries: [],
      cities: [{ name: "Изаберите државу" }],
      password: null,
      notification: null,
      notificationItems: ["email", "telefon"],
      failed: false,
    };
  },
  watch: {
    user: {
      handler(newVal) {
        this.localUser = { ...newVal };
      },
      deep: true,
    },
  },
  created() {
    this.loadCountries();
  },
  methods: {
    async loadCountries() {
      try {
        const { data } = await restaurantService.getCountriesAll();
        this.countries = data;

        if (this.localUser.city_id) {
          this.cities = [];
          data.forEach((country) => {
            country.city.forEach((city) => {
              if (city.id == this.localUser.city_id) {
                this.localUser.country = country.id;
                this.cities = country.city;
              }
            });
          });
        }
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_loading_countries"));
      }
    },

    handleCountryChange() {
      this.cities = [{ name: "Изаберите државу" }];
      const selectedCountry = this.countries.find(
        (country) => country.id == this.localUser.country
      );
      if (selectedCountry) {
        this.cities = selectedCountry.city;
      }
    },

    async handleUpdate() {
      this.failed = false;

      try {
        await userService.updateProfile(this.localUser.id, {
          name: this.localUser.name,
          lastname: this.localUser.lastname,
          email: this.localUser.email,
          phone: this.localUser.phone,
          address: this.localUser.address,
          firm: this.localUser.firm,
          country: this.localUser.country,
          city: this.localUser.city_id,
          apartment: this.localUser.apartment,
          password: this.password,
          notification: this.notification,
        });

        this.showSuccessSnackbar(this.$t("profile_updated"));
        this.$emit("profile-updated", this.localUser);
        this.password = null;
      } catch (error) {
        this.failed = true;
        this.showErrorSnackbar(this.$t("error_updating_profile"));
      }
    },
  },
};
</script>

<style scoped>
.tab_style {
  font-size: 18px;
  font-family: "Poppins", Helvetica, sans-serif;
}

.tab_style_sub_tekst {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.55);
}
</style>
